export function vueOpenAppPublic(vue) {
    vue.prototype.judgeBrand = function (appName) {
        let sUserAgent = navigator.userAgent.toLowerCase()
        var isHuawei = sUserAgent.match(/huawei/i) == "huawei";
        var isHonor = sUserAgent.match(/honor/i) == "honor";
        var isOppo = sUserAgent.match(/oppo/i) == "oppo";
        var isOppoR15 = sUserAgent.match(/pacm00/i) == "pacm00";
        var isVivo = sUserAgent.match(/vivo/i) == "vivo";
        var isXiaomi = sUserAgent.match(/mi\s/i) == "mi ";
        var isXiaomi2s = sUserAgent.match(/mix\s/i) == "mix ";
        var isRedmi = sUserAgent.match(/redmi/i) == "redmi";
        if (isHuawei || isHonor) {
            location.href = "appmarket://details?id=" + appName;
        } else if (isOppo || isOppoR15) {
            location.href = "oppomarket://details?packagename=" + appName;
        } else if (isVivo) {
            location.href = "vivomarket://details?id=" + appName;
        } else if (isXiaomi || isRedmi || isXiaomi2s) {
            location.href = "mimarket://details?id=" + appName;
        }
    }
    vue.prototype.jump = function () {
        if (this.isios) {
            location.href = "http://itunes.apple.com/app/id1314857099";
        } else {
            location.href =
                "https://a.app.qq.com/o/simple.jsp?pkgname=com.lanjiyin.lanjiyin"
            // "https://sj.qq.com/myapp/detail.htm?apkName=com.lanjiyin.lanjiyin&info=0F268185823B0AEEA303FC743C1E2B80";
        }
    }

    vue.prototype.isios = is_ios();
    vue.prototype.weixn = is_weixn();

    if (location.hostname == 'm.lanjiyin.com.cn') {
        vue.prototype.appid = "wxca0652e757c0834c";
    } else if (location.hostname == 'mobile.lanjiyin.com.cn') {
        vue.prototype.appid = "wxca0652e757c0834c";
    } else {
        vue.prototype.appid = "wxca0652e757c0834c";
    }



    vue.prototype.openApp = function (type) {
        //  ios_href: "",
        // android_href: "",
        if (this.isios) {
            location.href = "https://wap.lanjiyin.com.cn/medicine";
        } else {
            location.href = "lanjiyin://ljy.home";
        }
        setTimeout(() => {
            if (!document.hidden) {
                if (type == 0) {
                    this.jump();
                } else {
                    location.href = location.origin;
                }
            }
        }, 3000);
    }
    vue.prototype.weapp = function (elId, func) {
        let that = this;
        var btn = document.getElementById(elId);
        btn.addEventListener("ready", function (e) {
            console.log(e, "ready");
        });

        btn.addEventListener("launch", function (e) {
            console.log(e, "launch");
        });
        btn.addEventListener("error", function (e) {
            // that.jump();
            console.log(e, "errorios");
            func()

        });
    }

    vue.prototype.wxAppPx = function (str) {
        var ratio = 1;
        if (document.documentElement.clientWidth < 375) {
            ratio = document.documentElement.clientWidth / 375;
        }
        return str.replace(/(\d+)px/g, (e1, e2) => {
            return `${e2 * ratio}px`
        })
    }

}



// WEBPACK FOOTER //
// ./src/public/vueOpenAppPublic.js